var u={NotHelpful:"NotHelpful",Helpful:"Helpful"};function n(u){return t(u)}function t(u,n){return u}function e(u){return u}export{u as VoteType,n as VoteTypeFromJSON,t as VoteTypeFromJSONTyped,e as VoteTypeToJSON};
